import React, { useState, useEffect } from 'react';
import { useLanguage } from '../../../contexts/LanguageContext';
import Sidebar from '../../Layout/Sidebar';
import LanguageSelector from '../../Layout/LanguageSelector';
import AvailableTasks from './AvailableTasks';
import CleanerArchives from './CleanerArchives';
import NotificationsPanel from '../NotificationsPanel';
import ChatPanel from '../ChatPanel';
import Profile from '../Profile';
import api from '../../../utils/api';
import './CleanerDashboard.css';

const CleanerDashboard = () => {
  const { t } = useLanguage();
  const [activeTab, setActiveTab] = useState('tasks');
  const [sidebarOpen, setSidebarOpen] = useState(false);
  const [notifUnread, setNotifUnread] = useState(0);
  const [chatUnread, setChatUnread] = useState(0);
  const userId = localStorage.getItem('userId');

  useEffect(() => {
    const pollBadges = async () => {
      try {
        const [notifRes, chatRes] = await Promise.all([
          api.get('/notifications/unread-count'),
          api.get('/chat/unread-count')
        ]);
        if (notifRes.data?.data?.count !== undefined) setNotifUnread(notifRes.data.data.count);
        if (chatRes.data?.data?.count !== undefined) setChatUnread(chatRes.data.data.count);
      } catch { /* silent */ }
    };
    pollBadges();
    const interval = setInterval(pollBadges, 30000);
    return () => clearInterval(interval);
  }, []);

  const menuItems = [
    {
      label: t('cleaner.availableTasks', 'Available Tasks'),
      icon: '📋',
      path: '/cleaner',
      active: activeTab === 'tasks',
      onClick: () => setActiveTab('tasks')
    },
    {
      label: t('cleaner.myArchives', 'My Archives'),
      icon: '📁',
      path: '/cleaner',
      active: activeTab === 'archives',
      onClick: () => setActiveTab('archives')
    },
    {
      label: t('dashboard.notifications', 'Notifications'),
      icon: '🔔',
      path: '/cleaner',
      active: activeTab === 'notifications',
      onClick: () => setActiveTab('notifications'),
      badge: notifUnread
    },
    {
      label: t('dashboard.chat', 'Chat'),
      icon: '💬',
      path: '/cleaner',
      active: activeTab === 'chat',
      onClick: () => setActiveTab('chat'),
      badge: chatUnread
    },
    {
      label: t('dashboard.profile', 'Profile'),
      icon: '👤',
      path: '/cleaner',
      active: activeTab === 'profile',
      onClick: () => setActiveTab('profile')
    }
  ];

  return (
    <div className="cleaner-dashboard">
      <Sidebar 
        menuItems={menuItems} 
        userRole="cleaner" 
        isOpen={sidebarOpen}
        onClose={() => setSidebarOpen(false)}
      />
      <div className="dashboard-main">
        <div className="mobile-header">
          <button 
            className="mobile-menu-btn"
            onClick={() => setSidebarOpen(!sidebarOpen)}
            aria-label="Toggle menu"
          >
            <span className="hamburger-icon">☰</span>
          </button>
          <h1 className="mobile-title">{t('dashboard.cleanerDashboard', 'Cleaner Dashboard')}</h1>
          <div className="header-language-selector">
            <LanguageSelector />
          </div>
        </div>
        <div className="dashboard-container">
          <div className="dashboard-header-wrapper">
            <h1 className="desktop-title">{t('dashboard.cleanerDashboard', 'Cleaner Dashboard')}</h1>
            <div className="header-language-selector desktop-only">
              <LanguageSelector />
            </div>
          </div>
          
          <div className="dashboard-content">
            {activeTab === 'tasks' && <AvailableTasks userId={userId} />}
            {activeTab === 'archives' && <CleanerArchives userId={userId} />}
            {activeTab === 'notifications' && <NotificationsPanel onUnreadCountChange={setNotifUnread} />}
            {activeTab === 'chat' && <ChatPanel onUnreadCountChange={setChatUnread} />}
            {activeTab === 'profile' && <Profile userRole="cleaner" />}
          </div>
        </div>
      </div>
    </div>
  );
};

export default CleanerDashboard;



